import {
    collection,
    component,
    EntityData,
    field,
    identifier,
    LocalisableEntityData,
    transientField
} from "@fedeltapointofsale/data-client";
import {MarkupData} from "../markup/markup.data";
import {MembershipTypeReferenceData} from "../../customers/membership-type/membership-type.data";
import {PricingScheduleSummaryData} from "../pricing-schedule/pricing-schedule.data";
import {PriceLevelReferenceData} from "../price-level/price-level.data";
import {PointsData} from "../../customers/points/points.data";
import {ProductLineReferenceData} from "../../catalogue/product-line/product-line-reference.data";
import {PeriodScheduleReferenceData} from "../../system/period-schedule/period-schedule.data";
import {TypedTerminalReferenceData} from "../../pos/terminal/terminal-reference.data";

export class ProductSpecialSellableData extends EntityData<ProductSpecialSellableData> {
    @field sellableType: string;
    @identifier sellableId: number;
    @field name: string;
    @field discontinued: boolean;
    @field price: number;
    @field plu: string;
}

export class ProductSpecialData extends EntityData<ProductSpecialData> {
    @component product: ProductSpecialSellableData;
    @component markup: MarkupData;

    get appliedPrice(): number {
        return this.markup.getPrice(this.product.price);
    }
}

export class SpecialProductLoyaltyData extends EntityData<SpecialProductLoyaltyData> {
    @component product: ProductLineReferenceData;
    @component accrual: PointsData;
}

export class SpecialLoyaltyData extends EntityData<SpecialLoyaltyData> {
    @identifier id: number;
    @collection(MembershipTypeReferenceData) specialMemberTypes: MembershipTypeReferenceData[];
    @field includeGuests: boolean = false;
    @collection(SpecialProductLoyaltyData) specialProducts: SpecialProductLoyaltyData[];
    @field promoteAccruals: boolean = true;
}

export class SpecialScheduleSummaryData extends PricingScheduleSummaryData<SpecialScheduleSummaryData> {
    @identifier specialScheduleId: number;
    @field name: string;
    @field discontinued: boolean;
}

export class SpecialData extends LocalisableEntityData<SpecialData> {
    @identifier specialId: number;
    @field name: string;
    @field externalDescription: string;
    @field useRealTime: boolean = false;
    @field priceLevelId: number;
    @component priceLevel: PriceLevelReferenceData;
    @field discontinued: boolean;
    @component memberLoyalty: SpecialLoyaltyData;
    @collection(ProductSpecialData) products: ProductSpecialData[];
    @collection(TypedTerminalReferenceData) terminals: TypedTerminalReferenceData[];
    @collection(PeriodScheduleReferenceData) periodSchedules: PeriodScheduleReferenceData[];
    @collection(SpecialScheduleSummaryData) schedules: SpecialScheduleSummaryData[];
}

export class SpecialReferenceData extends LocalisableEntityData<SpecialReferenceData> {
    @identifier specialId: number;
    @field name: string;
}
